// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"334":"app-theme-dark1","522":"app-theme-dark0","554":"app-theme-light1","641":"app-theme-light0"}[chunkId] || chunkId) + "." + {"334":"2c410f96","498":"f92a077c","513":"b9133bc3","522":"f0b5f466","554":"a8846b40","641":"e60dbb57","703":"09b158f2"}[chunkId] + ".chunk.js";
};